import { getViewComponents, fieldSummaryComponents } from './utils/routes';

export const getRouteComponents = (layers) => {
  if (!layers) {
    return fieldSummaryComponents;
  }

  const layersArray = layers.split('|');
  return layersArray.reduce((_components, layer, index) => {
    const layerLabel = !index ? 'Main' : 'Split';
    const { mapLayer, panel, legend, content, modal } = getViewComponents(layer);

    return {
      ..._components,
      [`mapLayer${layerLabel}`]: mapLayer,
      [`panel${layerLabel}`]: panel,
      [`legend${layerLabel}`]: legend,
      [`modal${layerLabel}`]: modal,
      content, // content only applies to the master view.
    };
  }, {});

};
